import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '../../sitewide/Button'
import css from './MessageAllModal.css'

class MessageAllModal extends Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.handleSendMessage()
  }

  generateRemainingBlastsMessage(remainingBlastMessages) {
    return (
      `You have ${remainingBlastMessages} remaining blast 
      messages${remainingBlastMessages.length > 1 ? 's' : ''} that you can send 
      to all listed patients this month. Would you like to use one now?`
    )
  }
  generateDisclaimerMessage() {
    const { REACT_APP_IS_TOPS } = process.env
    return (
      `This will message every listed patient, except ${REACT_APP_IS_TOPS ?
      'dismissed' : 'inactive'} patients. This may be a large volume of 
      messages. Send anyway?`
    )
  }

  render() {
    const { close, remainingBlastMessages, isSendingBlastMsg } = this.props
    return (
      <div className={css.modal}>
        <div
          role="button"
          className={css.close}
          tabIndex="0"
          onClick={close}
        />
        <div className={css.header}>Send this Message to All Patients</div>
        <p>
          { this.generateRemainingBlastsMessage(remainingBlastMessages) }
        </p>
        <p className={css.disclaimer}>
          { this.generateDisclaimerMessage() }
        </p>
        <br />
        <Button onClick={this.handleClick} disabled={isSendingBlastMsg}>
          SEND THE MESSAGE
        </Button>
      </div>
    )
  }
}

MessageAllModal.propTypes = {
  close: PropTypes.func.isRequired,
  remainingBlastMessages: PropTypes.number.isRequired,
  handleSendMessage: PropTypes.func.isRequired,
  isSendingBlastMsg: PropTypes.bool.isRequired,
}

export default MessageAllModal



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/MessageAllModal.js